module.exports = __webpack_public_path__ + "src/assets/img/gazeta.d7a1df46.jpg";